<template>
  <span class="block mt-3 uppercase font-medium text-neutral-600">Question</span>
  <pre>dig @{{ records.query.server.domain || records.query.server.ip }} {{ records.query.domain }} {{records.query.recordType }}</pre>
  <span class="block mt-3 uppercase font-medium text-neutral-600">Answer</span>
  <pre class="max-w-full overflow-auto [tab-size:2]"><template v-for="(record, index) in records.response.answer" :key="index">{{ record.record.name }}{{ tabs(records.response.answer, record, toName) }}{{ record.record.ttl }}{{ tabs(records.response.answer, record, toTtl) }}{{ record.record.recordType }}{{ tabs(records.response.answer, record, toType) }}{{ record.record.raw }}
</template></pre>
  <span class="block mt-3 uppercase font-medium text-neutral-600">Authority</span>
  <pre class="max-w-full overflow-auto [tab-size:2]"><template v-for="(record, index) in records.response.authority" :key="index">{{ record.record.name }}{{ tabs(records.response.authority, record, toName) }}{{ record.record.ttl }}{{ tabs(records.response.authority, record, toTtl) }}{{ record.record.recordType }}{{ tabs(records.response.authority, record, toType) }}{{ record.record.raw }}
</template></pre>
  <span class="block mt-3 uppercase font-medium text-neutral-600">Additional</span>
  <pre class="max-w-full overflow-auto [tab-size:2]"><template v-for="(record, index) in records.response.additional" :key="index">{{ record.record.name }}{{ tabs(records.response.additional, record, toName) }}{{ record.record.ttl }}{{ tabs(records.response.additional, record, toTtl) }}{{ record.record.recordType }}{{ tabs(records.response.additional, record, toType) }}{{ record.record.raw }}
</template></pre>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { QueryResult, RecordWithInfo } from '@/model/Api';

defineProps({
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
});

function tabs(all: Array<RecordWithInfo>, current: RecordWithInfo, length: (r: RecordWithInfo) => number) {
  const maxWidth = Math.max(...all.map(length));
  const maxTabs = Math.floor(maxWidth / 2) + 1;
  const currentWidth = length(current);
  const currentTabs = maxTabs - Math.floor(currentWidth / 2);
  return '\t'.repeat(currentTabs);
}

function toName(record: RecordWithInfo) {
  return record.record.name.length;
}

function toTtl(record: RecordWithInfo) {
  return record.record.ttl.toString().length;
}

function toType(record: RecordWithInfo) {
  return record.record.recordType.length;
}
</script>
